<template>
					<h2>{{ currentShortTitle }}</h2>
					<div class="iconDisplay">{{ currentIcon }}</div>
					<p class="containerPadding">{{ currentDescription }}</p>
</template>

<script>
import { mapState } from 'vuex';
 
export default {

computed: 
    mapState(['currentDescription', 'currentShortTitle', 'currentIcon'])
    
}


</script>

<style scoped >
@font-face { 
  font-family: "BOSAstrology";
  src:url(../../assets/fonts/BOSAstrology2020.ttf) format("truetype");
 }
.BOS {
    font-family: "BOSAstrology";
    /* font-size: this.size ; */
}
h2{
	display: block;
    font-size: 6vh;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
	text-align: center;
    font-weight: bold;
}
.iconDisplay{
    font-family: "BOSAstrology";
	text-align: center;
	font-size: 30vh;
	line-height: 30vh;
}
ul {
    display: block;
    list-style-type: none;
    margin-block-start: 0;
    margin-block-end: 0;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0;
}
.containerPadding{
    padding: 0px 20px;
}
</style>